import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DraggableStepCard from 'pages/AutomationEngine/Engine/Steps/DraggableStepCard';
import { StepCardOld } from 'pages/AutomationEngine/Engine/Steps/StepCardOld';
import * as cardTypes from '__pages/AutomationEngine/Engine/Steps/type';
import { type Step } from 'pages/AutomationEngine/types';
import steps, { type SmartStepType } from '../steps';

export const ConfiguredStepCard = ({
  type,
  step,
  disableMenu = false,
  scale,
  onStart = null,
  onStop = null,
  ...others
}: {
  type: string;
  step: Omit<Step, 'type'> & { type: SmartStepType };
  disableMenu?: boolean;
  scale?: number | null;
  onStart?: (() => void) | null;
  onStop?: (() => void) | null;
  [key: string]: any;
}) => {
  const { t } = useTranslation();
  const stepConfig = steps[step.type];

  const title =
    typeof stepConfig.title === 'function'
      ? stepConfig.title(t)
      : stepConfig.title;

  const menuOptions = useMemo(
    () =>
      [
        stepConfig.creatable && { label: t('Edit'), value: 'edit' },
        stepConfig.deletable && { label: t('Delete'), value: 'delete' },
      ].filter(Boolean),
    [stepConfig, t]
  );

  const CardComponent =
    cardTypes[stepConfig.CardComponent] ||
    (stepConfig.movable && DraggableStepCard) ||
    StepCardOld;

  return (
    <CardComponent
      title={title}
      color={
        step.hasError ? 'var(--color-button-warning-hover)' : stepConfig.color
      }
      data-qa-error={step.hasError}
      borderColor={step.hasError ? 'var(--color-button-warning-hover)' : null}
      menuOptions={menuOptions}
      disableMenu={
        disableMenu || (!stepConfig.creatable && !stepConfig.deletable)
      }
      type={type}
      step={step}
      scale={scale}
      onStart={onStart}
      onStop={onStop}
      isSmartConnectorFlow
      {...others}
    />
  );
};
